import { ReactNode } from 'react'
import { Schemas } from '~/api/gen'
import { useRelationship } from '~/hooks/useRelationship'
import { MemberInformation } from '../../MemberInformation'

type Member = Pick<
  Schemas.member_small,
  | 'id'
  | 'image'
  | 'user_name'
  | 'nick_name'
  | 'height'
  | 'is_wearista'
  | 'is_shop_clerk'
  | 'is_salon_clerk'
  | 'is_sponsored'
  | 'is_awarded'
>
type Props = {
  member: Member | null
  hasBottomShadow: boolean
  children?: ReactNode
  linkUrl?: string
}
type ViewProps = {
  member: Member | null
  isFollowed: boolean
  hasBottomShadow: boolean
  children?: ReactNode
  linkUrl?: string
}

export const MemberHeaderView: React.FC<ViewProps> = ({
  children,
  member,
  hasBottomShadow,
  isFollowed,
  linkUrl,
}) => {
  return (
    <div
      className={`flex min-h-12 w-full items-center justify-between bg-white px-3 py-[5px] ${
        hasBottomShadow ? 'shadow-header' : ''
      }`}
    >
      <div className="grow">
        <MemberInformation
          member={member}
          linkUrl={linkUrl}
          isFollowed={isFollowed}
        />
      </div>
      {children}
    </div>
  )
}

export const MemberHeader: React.FC<Props> = ({
  children,
  member,
  hasBottomShadow,
  linkUrl = `/${member?.user_name}/`,
}) => {
  const { followed } = useRelationship(member)
  return (
    <MemberHeaderView
      member={member}
      isFollowed={followed}
      hasBottomShadow={hasBottomShadow}
      linkUrl={linkUrl}
    >
      {children}
    </MemberHeaderView>
  )
}
